import { type ReactNode } from "react";

import { DOM_IDS } from "../defaults";

// CircleAIAppShell is v4-only, so the dark: swap below is unconditional
// rather than gated on isCircleV4.
export const FlexBody = ({ children }: Readonly<{ children: ReactNode }>) => (
  <div
    id={DOM_IDS.shellBody}
    data-testid="circle-ai-shell-layout-body"
    className="group/shell relative flex min-h-0 flex-1 overflow-hidden bg-primary dark:bg-secondary"
  >
    {children}
  </div>
);
